import { AlignmentType, Paragraph, TextRun, WidthType } from "docx";

export const stageText2 = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 276, before: 50, after: 200 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The tables below list the vulnerabilities identified, their rating and the remediation actions to be performed. The scale as mentioned in Section 8.0 has been used to rate the severity.",
            size: 22,
            font: "Calibri",
            color: '000000',
            italics: false
        }),
    ],
})
